import { APP_CONFIG } from '@/config';
import { of, from, Observable, Observer } from 'rxjs';
import { switchMap, tap, delay } from 'rxjs/operators';
import Vue from 'vue';
import { httpService } from './httpClient.service';
import { utilsService } from './utils.service';
import { dvService } from './device.service';
import { lsService } from './ls.service';
// import * as wx from 'weixin-js-sdk';
// console.log('wx: ', wx);

export interface wxShareData {
  ftitle: string;
  ttitle: string;
  fdesc: string;
  imgUrl: string;
  link: string;
  tsuccess?: Function;
  success?: Function;
}

interface cardExt {
  timestamp: number;
  openid: string;
  outer_str: string;
}

export interface wxCardItem {
  code: string;
  cardId: string;
  cardExt: cardExt;
  isSuccess: boolean;
}

export interface wxUserInfo {
  openid: string;
  unionid: string;
  nickname: string;
  sex: number;
  headimgurl: string;
  country?: string;
  language?: string;
  city: string;
  groupid?: number;
  province: string;
  privilege?: any[];
  remark?: string;
  subscribe?: number;
  subscribe_time?: number;
  tagid_list?: any[];
  errcode?: string;
}

// const wx: any = window['wx'];
const vue: any = Vue;
declare const wx: any;

class WxService {
  openId: any;
  userinfo = {} as wxUserInfo;
  originalUrl: any;

  // testUserInfo: wxUserInfo = {
  //   city: '朝阳',
  //   country: '中国',
  //   headimgurl:
  //     'http://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIdGg2qBUVbwQYEujQal6uhzcUXvv8czxKGjlH2MwntAE46vefJIVtGklTSKBDiaicg0sCPyiaPDfrhg/132',
  //   language: 'zh_CN',
  //   nickname: 'Riuhou',
  //   openid: 'oOOfPvq7tois-Zrbi48Q-pBLvoJo',
  //   privilege: [],
  //   province: '北京',
  //   sex: 1,
  //   unionid: 'ocaMjt3YcgywHfNLqo0JEli_HIE8',
  // };

  init() {
    if (/(localhost|10.0.0.)/.test(APP_CONFIG.baseUrl)) return;

    // console.log(`wx`, wx);

    wx.ready(() => {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
      // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
      // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      console.log('wx.ready');
      // alert('wx.ready');
      // check();

      // function check() {
      //   if (sc.wxNotReady) {
      //     $('.modal.wx-fail').addClass('on');
      //   }
      // };
    });

    wx.error(res => {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      console.log('wx.error', res);
      // sc.wxNotReady = true;
      // alert('wx.error: ' + JSON.stringify(res));
    });

    setTimeout(() => {
      this.originalUrl = location.href;
      this.config();
    }, 1000);
  }

  config() {
    // 微信分享自定义配置
    const url = APP_CONFIG.wxJssdk;

    const jsApiList = [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',

      'updateAppMessageShareData',
      'updateTimelineShareData',

      // 'scanQRCode',
      // 'showAllNonBaseMenuItem',
      // 'hideAllNonBaseMenuItem',
      // 'chooseWXPay',
      // 'hideMenuItems',
      // 'showMenuItems',

      // 'addCard',
      // 'chooseCard',
    ];

    //微信初始化及自定义分享函数
    const pram = {
      request: {
        body: { url: this.originalUrl },
        head: {
          // public_key: 'front_js_sdk_card_validate',
          // secret_key: 'C8FC6DFA673369423C3E66',
          // timestamp: '1449550527227',
          public_key: '1',
          secret_key: '1',
          timestamp: '1',
        },
      },
    };

    vue
      .jsonp(url, pram)
      .then(res => {
        console.log(res);
        if (res.signPackage.appId != 'undefined') {
          // app.res = res;
          wxConfig(res);
          // alert(originalUrl)
          // alert(location.href)
        }
      })
      .catch(err => {
        console.log(err);
      });

    function wxConfig(res) {
      wx.config({
        debug: false,
        appId: res.signPackage.appId,
        timestamp: res.signPackage.timestamp,
        nonceStr: res.signPackage.nonceStr,
        signature: res.signPackage.signature,
        jsApiList: jsApiList,
      });
    }
  }

  share(params: wxShareData) {
    return new Promise((resolve, reject) => {
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: params.ftitle,
          desc: params.fdesc,
          link: params.link,
          imgUrl: params.imgUrl,
          success: params.success,
        });

        wx.updateTimelineShareData({
          title: params.ttitle,
          imgUrl: params.imgUrl,
          link: params.link,
          success: params.tsuccess,
        });

        // wx.hideAllNonBaseMenuItem();

        // wx.showMenuItems({
        //   // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        //   menuList: [
        //     'menuItem:share:appMessage',
        //     'menuItem:favorite'
        //   ]
        // });
        resolve();
        console.log('分享内容更新完成', params);
      });
    });
  }

  getCode() {
    return from(lsService.localForage.getItem('userinfo')).pipe(
      switchMap((res: any) => {
        console.log(res);

        if (res) {
          this.userinfo = res;
          if (this.userinfo.openid) return of(res);
        }

        // if (/(localhost|10.0.0.)/.test(APP_CONFIG.baseUrl)) {
        //   this.userinfo = this.testUserInfo;
        //   return of(0)
        // };

        const wxCode = utilsService.getQueryString('code');

        const sope = 'snsapi_base'; // 'snsapi_userinfo' 'snsapi_base';
        const redirect_uri = encodeURIComponent(APP_CONFIG.baseUrl);
        const search = location.search.replace(/code.*&state=&/, '');
        const state = encodeURIComponent(search.replace('?', '&'));
        const jumpUrl = `${APP_CONFIG.wxApi}?appid=${APP_CONFIG.appId}&scope=${sope}&redirect_uri=${redirect_uri}&response_type=code&state=${state}#wechat_redirect`;

        const getOpenIdEp = APP_CONFIG.wxApi + '/access_token.php?code=';

        // return of(0);

        if (!wxCode) {
          console.log(jumpUrl);
          // window.location.href = jumpUrl;
          // window.open(jumpUrl);
          // history.go(-100);
          // window.location.replace(jumpUrl);

          return of(0);
        } else {
          alert(wxCode);
          return of(0);
          // return this.getOpenId({ getOpenIdEp, wxCode, jumpUrl });
        }
      }),
    );
  }

  getOpenId({ getOpenIdEp, wxCode, jumpUrl }: any) {
    return httpService.getOpenId({ url: getOpenIdEp + wxCode }).pipe(
      tap(res => {
        console.log(res);
        this.openId = res.openid;
        if (!this.openId) {
          // window.location.href = jumpUrl;
          window.location.replace(jumpUrl);
          // alert('获取微信用户信息失败');
        }
      }),
      switchMap(res => this.getUserInfo(res)),
    );
  }

  getUserInfo({ access_token, openid }: any) {
    const url = `${APP_CONFIG.wxJssdk}/userinfo.php?openid=${openid}&access_token=${access_token}`;
    if (!access_token) return of(0);

    return httpService.getUserInfo({ url }).pipe(
      switchMap(res => {
        console.log(res);
        this.userinfo = res;
        lsService.localForage.setItem('userinfo', res);
        return of(res);
      }),
    );
  }

  /** wk openid url */
  getWkOpenIdUrl(path: string) {
    // const params = location.search ? `${location.search}&route=${path}` : `?route=${path}`;
    // const rediectUrl = encodeURIComponent(`${APP_CONFIG.baseUrl}${params}`);
    // const rediectUrl = encodeURIComponent(window.location.href);
    let rediectUrl = encodeURIComponent(window.location.href);
    if (path === '/') rediectUrl = encodeURIComponent(APP_CONFIG.baseUrl);

    // alert(rediectUrl);
    const url = `${APP_CONFIG.ep.getOpenIdUrl}?redirect_uri=${rediectUrl}`;
    return url;
  }

  /** wk get openid */
  getWkOpenId(path: string, openId2: string) {
    if (!dvService.isWX) return of(0);

    const openId = utilsService.getQueryString('openid') || openId2;
    if (openId) {
      this.openId = openId;
      lsService.localForage.setItem('openId', openId);
      console.log({ openId });
      console.log(`url openid`, { openId });
      return of(openId);
    }

    return from(lsService.localForage.getItem('openId')).pipe(
      switchMap((res: any) => {
        console.log(`local openid`, { res });

        if (res) {
          this.openId = res;
          return of(res);
        }

        // window.location.href = this.getWkOpenIdUrl();
        let url = this.getWkOpenIdUrl(path);
        console.log('this.getWkOpenIdUrl(): ', url);
        window.location.replace(url);
        return of(0).pipe(delay(1000));
      }),
    );
  }

  // 发卡
  getCard(data) {
    return Observable.create((observer: Observer<any>) => {
      wx.addCard({
        cardList: data,
        success: res => {
          const cardList: wxCardItem[] = res.cardList.map(function(item: { cardExt: string }) {
            item.cardExt = JSON.parse(item.cardExt);
            return item;
          });

          setTimeout(() => {
            // alert('已添加卡券：' + JSON.stringify(res.cardList));
            observer.next(cardList);
            observer.complete();
          }, 100);
        },
        fail: err => {
          setTimeout(() => {
            // observer.error(err);
          }, 500);
        },
        // complete: function(res) {
        //   $scope.$apply(function() {
        //     $scope.complete = JSON.stringify(res);
        //   });
        //   avService.completeRecord({}).then(function(res) {
        //     $scope.$apply(function() {
        //       $scope.addCard = JSON.stringify(res);
        //     });
        //   });
        // }
      });
    });
  }
}

export const wxService = new WxService();
